// extracted by mini-css-extract-plugin
export default {"cls1":"gygmzlNs4Owoef8R4HS_","cls2":"lihBzAHFCMUmTOaSIXw1 gygmzlNs4Owoef8R4HS_"};